export const FETCH_CISSCT_BEGIN = 'FETCH_CISSCT_BEGIN';
export const FETCH_CISSCT_SUCCESS = 'FETCH_CISSCT_SUCCESS';
export const FETCH_CISSCT_FAILURE = 'FETCH_CISSCT_FAILURE';
export const FETCH_CISSCT_BY_NDOSSIER = 'FETCH_CISSCT_BY_NDOSSIER';
export const FETCH_CISSCT_BY_INDEX = 'FETCH_CISSCT_BY_INDEX';
export const CHANGE_INDEX_VALUE = 'CHANGE_INDEX_VALUE';

export function fetchCissct(ndossier = null) {
  return dispatch => {
    dispatch(fetchCissctBegin());
    const url = ndossier 
      ? `/api/cissct/getCissct?ndossier=${ndossier}`
      : '/api/cissct/getCissct';
    
    return fetch(url, { method: 'GET' })
      .then(handleErrors)
      .then(r => r.json())
      .then(json => {
        dispatch(fetchCissctSuccess(json));
        return json;
      })
      .catch(err => dispatch(fetchCissctFailure(err)));
  };
}

export function fetchCissctByNdossier(ndossier) {
  return {
    type: FETCH_CISSCT_BY_NDOSSIER,
    payload: { ndossier }
  };
}

export function fetchCissctByIndex(ndossier, index) {
  return {
    type: FETCH_CISSCT_BY_INDEX,
    payload: { ndossier, index }
  };
}

function handleErrors(res) {
  if (!res.ok) throw new Error(res.statusText);
  return res;
}

export const fetchCissctBegin = () => ({
  type: FETCH_CISSCT_BEGIN
});

export const fetchCissctSuccess = cissct => ({
  type: FETCH_CISSCT_SUCCESS,
  payload: { items: cissct }
});

export const fetchCissctFailure = error => ({
  type: FETCH_CISSCT_FAILURE,
  payload: { error }
});

export const changeIndexValue = index => ({
  type: CHANGE_INDEX_VALUE,
  payload: { index }
});